app.StandardApplication = (
    function () {
        var application = {
            //Index Page
            CertifiedAndSupport: function (isSupport) {
               
                // fire a toastr when components get removed
                $(document).on("component-remove-complete", function () {
                    toastr.success("Success!");
                });

                // use this event to disable jQuery date validation
                // only required for components with DateTime fields that are MM/yyyy
                $(document).on("disable-date-validation",
                    function () {
                        //util.console.log("Triggered disable-date-validation");

                        // disable jQuery date validation
                        // this is only required for datepicker fields
                        // with a MM/yyyy format,because the jQuery
                        // validator doesn't know how to handle that
                        $.validator.addMethod("date",
                            function (value, element) {
                                return true;
                            });
                    });

                // add required star to Positions Seeking select many control
                $(document).on("component-bind-edit-mode-complete-CertifiedGeneralInformation component-bind-edit-mode-complete-SupportGeneralInformation",
                    function (e, generalInformation) {
                        var starString = "<span class='text-danger' data-component-role='requiredstar'>*</span>";
                        $(generalInformation.el).find("label[for=SelectedPositionsSeekingIds]").append(starString);

                        $("[name='RequiresEmploymentSponsorship']").on("change", function () {
                            var value = $(this).val();
                            if (value === "True") {
                                $("[data-visa-question]").show();
                            }
                            else {
                                $("[data-visa-question]").hide();
                                $("[data-visa-question]").find('input[type=radio]').prop("checked", false);
                            }
                        });

                    });

                // add required star to Liftime licenses select many control
                $(document).on("component-bind-edit-mode-complete-License", function () {
                    setRequiredIfLabels();

                    $("select[name='IsLifetime']").on("change",
                        function () {
                            setRequiredIfLabels();
                        });
                });
                function setRequiredIfLabels() {
                    var editComponent = $("select[name='IsLifetime']").closest("div.component-edit");
                    var expire = $(editComponent).find("#lblExpirationDate")
                    var expected = $(editComponent).find("#lblExpectedDate")
                    if ($("select[name='IsLifetime']").find(":selected").val() !== "true") {
                        var starString = "<span class='text-danger' data-component-role='requiredstar'>*</span>";
                        $(expire).append(starString);
                        $(expected).append(starString);
                    }
                    else {
                        $(expire).find("span.text-danger").remove();
                        $(expected).find("span.text-danger").remove();
                    }
                }
                // when the education edit card is loaded
                $(document).on("component-bind-edit-mode-complete-Education",
                    function (e, education) {
                        // trigger event to disable date validation
                        $(document).trigger("disable-date-validation");

                        // get the correct fields
                        var degrees = $("[data-component-role='degree']", education.el);
                        var major = $("[data-component-role='major']", education.el);
                        var minor = $("[data-component-role='minor']", education.el);
                        var gpa = $("[data-component-role='gpa']", education.el);
                        var certification = $("[data-component-role='certification']", education.el);

                        // hide the extra label that's added to the Degree field by the WamsDropDownListFor
                        degrees.siblings("label:not(:has(span))").hide();
                        $("[data-component-role='degree']").attr("data-val-number", "Education Level is required.");

                        checkEducationVals(degrees, major, minor, certification, gpa);

                        // check values when the degrees dropdown is changed
                        degrees.on("change",
                            function () {
                                checkEducationVals(degrees, major, minor, certification, gpa);
                            });
                    });

                function checkEducationVals(degrees, major, minor, certification, gpa) {
                    // if High School Education or GED is selected in the degrees dropdown, then:
                    //  - Remove major, minor, certification
                    //  - Make GPA optional

                    // add required stars
                    var majorStar = major.siblings("label").children("[data-component-role='requiredstar']");
                    var gpaStar = gpa.siblings("label").children("[data-component-role='requiredstar']");
                    var certificationStar = certification.siblings("label").children("[data-component-role='requiredstar']");

                    var selected = degrees.find("option:selected");

                    if (selected &&
                        (selected.data("unique-id") === "degree-ged" || selected.data("unique-id") === "degree-high-school-education-diploma")) {
                        // if Alternative Pathway or High School is selected

                        major.parent().hide();
                        major.data("val-required", null);

                        minor.parent().hide();

                        certification.parent().hide();

                        gpaStar.hide();
                        gpa.data("val-required", null);
                    } else {
                        if (!majorStar.length) {
                            major.siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                        if (!certificationStar.length) {
                            certification.siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                        if (!gpaStar.length) {
                            gpa.siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }

                        major.data("val", true);
                        major.attr("data-val-required", "The Major field is required.");

                        gpa.data("val", true);
                        gpa.attr("data-val-required", "The GPA field is required.");

                        major.parent().show();
                        minor.parent().show();
                        certification.parent().show();
                        gpaStar.show();
                    }
                }

                // when either work experience edit card is loaded
                $(document).on("component-bind-edit-mode-complete-CertifiedEducationWorkExperience component-bind-edit-mode-complete-WorkExperience",
                    function (e, el) {
                        // trigger event to disable date validation
                        $(document).trigger("disable-date-validation");

                        var endDate = $("[data-component-role='enddate']", el.el);
                        var currentlyWorkHere = $("[data-component-role='currentlyworkhere']", el.el);

                        checkEducationWorkExperienceVals(endDate, currentlyWorkHere);

                        // if any of the three date inputs
                        // (Start Date, End Date, Currently Work Here)
                        // is changed, run the following logic
                        $("[data-component-group='dates']").on("change",
                            function () {
                                checkEducationWorkExperienceVals(endDate, currentlyWorkHere);
                            });
                    });

                function checkEducationWorkExperienceVals(endDate, currentlyWorkHere) {
                    // if Currently Work Here is true, don't require the Date To (or End Date) field

                    var endDateStar = endDate.siblings("label").children("[data-component-role='requiredstar']");
                    var reasonsForLeavingStar = $("textarea[name='ReasonForLeaving']").siblings("label").children("[data-component-role='requiredstar']");

                    if (currentlyWorkHere.val() === "true") {
                        endDate.prop("disabled", true);
                        endDate.val(null);
                        endDateStar.hide();
                        reasonsForLeavingStar.hide();
                    } else {
                        endDate.prop("disabled", false);

                        // if end date star exists, show it, otherwise append one
                        if (endDateStar.length) {
                            endDateStar.show();
                            reasonsForLeavingStar.show();
                        } else {
                            endDate.siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");

                            $("textarea[name='ReasonForLeaving']").siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                    }
                }

                $(document).on("component-bind-edit-mode-complete-CertifiedLicenseDetails",
                    function (e, license) {
                        $(document).on("change",
                            "[name='SelectedLicenseQuestionAnswer']",
                            function () {
                                switch ($(this).val()) {
                                    case "False":
                                        //If it is 0 then do show/hide
                                        $(this).closest("form").find("div[data-show-hide-div='some']").hide();
                                        $(this).closest("form").find("div[data-show-hide-div='explanation']").hide();
                                        $(this).closest("form").find("div[data-show-hide-div='none']").show();

                                        //clear license values if they filled anything out
                                        $(this).closest("form").find("[name='DpiNumber']").val(null);
                                        break;
                                    default:
                                        //if not 0, go back to default state
                                        $(this).closest("form").find("div[data-show-hide-div='none']").hide();
                                        $(this).closest("form").find("div[data-show-hide-div='explanation']").hide();
                                        $(this).closest("form").find("div[data-show-hide-div='some']").show();

                                        //clear no license values if they filled anything out
                                        $(this).closest("form").find("[name='LicenseExplanation']").val(null);
                                        $(this).closest("form").find("[name='SelectedNoLicenseReasonLicenseId']").val(null);

                                        break;
                                }
                            });

                        $(document).on("change",
                            "[name='SelectedNoLicenseReasonLicenseId']",
                            function () {
                                switch ($("option:selected", this).data("unique-id")) {
                                    case "license-dropdown-options-other":
                                        //If it is 0 then do show/hide
                                        $(this).closest("form").find("div[data-show-hide-div='explanation']").show();
                                        break;
                                    default:
                                        //if not 0, go back to default state
                                        $(this).closest("form").find("div[data-show-hide-div='explanation']").hide();
                                        $(this).closest("form").find("[name='LicenseExplanation']").val(null);

                                        break;
                                }
                            });
                    });

                // Licenses
                $(document).on("component-bind-edit-mode-complete-License",
                    function (e, license) {

                        // trigger event to disable date validation
                        $(document).trigger("disable-date-validation");

                        // append required stars to date and lifetime field labels - need to do this
                        // here because there is no way to add them automatically in the WecanLabel
                        // without having the fields marked as required in the model

                        // get the correct fields
                        var expected = $("[data-component-role='expected']", license.el);
                        var expiration = $("[data-component-role='expiration']", license.el);
                        var lifetime = $("[data-component-role='lifetime']", license.el);

                        checkLicenseVals(expected, expiration, lifetime);

                        // Expected Date: Required if Lifetime is NOT checked AND there is NO Expiration value
                        // Expiration Date: Required if Lifetime is NOT checked AND there is NO Expected value
                        // Lifetime: Required if there is NO Expiration OR Expected value

                        $("[data-component-group='dates']").on("change",
                            function (e) {
                                checkLicenseVals(expected, expiration, lifetime);
                            });
                  
                    });

                // checks the passed-in values and set the required stars for each field
                function checkLicenseVals(expected, expiration, lifetime) {

                    //$(expected).on("change", function () {
                    //    if ($("select[name='IsLifetime']").find(":selected").val() !== "false" && ($(expected).val() != null || $(expected).val() != "" || $(expected).val() != "undefined")) {
                    //        $(expire).find("span.text-danger").remove();
                    //        $(expected).append(starString);
                    //    }
                    //});
                    //$(expire).on("change", function () {
                    //    if ($("select[name='IsLifetime']").find(":selected").val() !== "false" && ($(expire).val() != null || $(expire).val() != "" || $(expire).val() != "undefined")) {
                    //        $(expected).find("span.text-danger").remove();
                    //        $(expire).append(starString);
                    //    }
                    //});


                    // add required stars
                    var expectedStar = expected.parent().siblings("label").children("[data-component-role='requiredstar']");
                    var expirationStar = expiration.parent().siblings("label").children("[data-component-role='requiredstar']");
                    var lifetimeStar = lifetime.siblings("label").children("[data-component-role='requiredstar']");

                    // if lifetime is false AND there is no expiration value
                    // then expected is required
                    if (lifetime.val() === "false" && (!expiration.val() || expiration.val() === "")) {
                        if (expectedStar.length) {
                            expectedStar.show();
                        } else {
                            expected.parent().siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                    } else {
                        if (expectedStar.length) {
                            expected.parent().siblings("label").children("[data-component-role='requiredstar']").hide();
                        }
                    }

                    // if lifetime is false AND there is no expected value
                    // then expiration is required
                    if (lifetime.val() === "false" && (!expected.val() || expected.val() === "")) {
                        if (expirationStar.length) {
                            expirationStar.show();
                        } else {
                            expiration.parent().siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                    } else {
                        if (expirationStar.length) {
                            expiration.parent().siblings("label").children("[data-component-role='requiredstar']").hide();
                        }
                    }

                    // if there is no expected or expiration value
                    // then lifetime is required
                    if ((!expected.val() || expected.val() === "") && (!expiration.val() || expiration.val() === "")) {
                        if (lifetimeStar.length) {
                            lifetimeStar.show();
                        } else {
                            lifetime.siblings("label").first()
                                .append("<span class=\"text-danger\" data-component-role=\"requiredstar\">*</span>");
                        }
                    } else {
                        if (lifetimeStar.length) {
                            lifetimeStar.hide();
                        }
                    }
                }

                // Non-Renewed
                $(document).on("component-bind-edit-mode-complete-NonRenewed",
                    function () {
                        var divNonRenewedReason = $("#divNonRenewedReason");
                        var nonRenewedReason = $("#nonRenewedReason");
                        var nonRenewedDropdown = $("#nonRenewedDropdown");

                        var isNonRenewed = nonRenewedDropdown.val();

                        if (isNonRenewed === "false") {
                            divNonRenewedReason.hide();
                        }
                    });

                $(document).on("change", "#nonRenewedDropdown", function () {
                    var divNonRenewedReason = $("#divNonRenewedReason");
                    var nonRenewedDropdown = $("#nonRenewedDropdown");

                    var isNonRenewed = nonRenewedDropdown.val();

                    if (isNonRenewed === "true") {
                        divNonRenewedReason.show();
                    } else if (isNonRenewed === "false") {
                        divNonRenewedReason.hide();
                    }
                });

                // Support Licenses and Certifications
                $(document).on("component-bind-edit-mode-complete-SupportLicensesAndCertifications",
                    function (e, element) {
                        checkLicenseAndCertificationVals();

                        $("[data-component-role='LicenseCertificationCheckbox']").on("change",
                            function () {
                                checkLicenseAndCertificationVals();
                            });
                    });

                function checkLicenseAndCertificationVals() {
                    // check the checkboxes for each item and enable/disable elements as needed

                    if ($("#DriversLicenseChecked").is(":checked")) {
                        $("#DriversLicenseExpiration").prop("disabled", false);
                    } else {
                        $("#DriversLicenseExpiration").val(null);
                        $("#DriversLicenseExpiration").prop("disabled", true);
                    }

                    if ($("#CommercialDriversLicenseChecked").is(":checked")) {
                        $("#CommercialDriversLicenseExpiration").prop("disabled", false);
                    } else {
                        $("#CommercialDriversLicenseExpiration").val(null);
                        $("#CommercialDriversLicenseExpiration").prop("disabled", true);
                    }

                    if ($("#AedChecked").is(":checked")) {
                        $("#AedExpiration").prop("disabled", false);
                        $("#AedCertificationGrantorId").prop("disabled", false);
                    } else {
                        $("#AedExpiration").val(null);
                        $("#AedExpiration").prop("disabled", true);

                        $("#AedCertificationGrantorId").val(null);
                        $("#AedCertificationGrantorId").prop("disabled", true);
                    }

                    if ($("#CprChecked").is(":checked")) {
                        $("#CprExpiration").prop("disabled", false);
                        $("#CprCertificationGrantorId").prop("disabled", false);
                    } else {
                        $("#CprExpiration").val(null);
                        $("#CprExpiration").prop("disabled", true);

                        $("#CprCertificationGrantorId").val(null);
                        $("#CprCertificationGrantorId").prop("disabled", true);
                    }

                    if ($("#FirstAidChecked").is(":checked")) {
                        $("#FirstAidExpiration").prop("disabled", false);
                        $("#FirstAidCertificationGrantorId").prop("disabled", false);
                    } else {
                        $("#FirstAidExpiration").val(null);
                        $("#FirstAidExpiration").prop("disabled", true);

                        $("#FirstAidCertificationGrantorId").val(null);
                        $("#FirstAidCertificationGrantorId").prop("disabled", true);
                    }
                }

                // Include in Search
                // update the user's include in search flag in the db when they check or uncheck it
                $(document).on("change",
                    "#cbxIncludeInSearch",
                    function () {
                        var isChecked = $("#cbxIncludeInSearch").is(":checked");
                        var token = $("input[name ='__RequestVerificationToken']").val();
                        var url = "/StandardApplication/UpdateIncludeInSearch";

                        var dataObject = {
                            __RequestVerificationToken: token,
                            val: isChecked,
                            staffTypeId: app.page.id
                        };

                        $.ajax({
                            type: "POST",
                            url: url,
                            data: dataObject,
                            success: function () {
                                toastr.success("Success!");
                            },
                            error: function () {
                                toastr.error("Error.");
                            }
                        });
                    });

                // Authorization, Certification, and Release
                // update the user's authorization flag in the db when they check or uncheck it
                $(document).on("change",
                    "#cbxAuthorization",
                    function () {
                        var isChecked = $("#cbxAuthorization").is(":checked");
                        var token = $("input[name ='__RequestVerificationToken']").val();
                        var url = "/Application/UpdateAuthorization";
                        var dataObject = {
                            __RequestVerificationToken: token,
                            val: isChecked,
                            appId: app.page.id
                        };

                        $.ajax({
                            type: "POST",
                            url: url,
                            data: dataObject,
                            success: function () {
                                //Fire the trigger for component so the apply button can be disabled/enabled if this action satisfies a condition
                                $(document).trigger("component-save-complete");
                                toastr.success("Success!");
                            },
                            error: function () {
                                toastr.error("Error.");
                            }
                        });
                    });
            }
        };

        return application;
    }()
);